@if (isMobile()) {
  <div class="route-item-container route-item-container--mobile">
    @for (item of menuItems(); track item?.display; let i = $index) {
      <div
        class="route-item route-item--mobile"
        [routerLink]="item.url"
        (click)="item?.meta ? onMetaItemClick(item) : onMenuItemClick()"
        [ngClass]="{'route-item--selected': item | isRouteActive: routerUrl()}"
      >
        <mat-icon class="route-item-icon route-item-icon--mobile" [svgIcon]="item.icon" />
        <span class="route-item-label route-item-label--mobile">{{ item.display }}</span>
      </div>
    }
  </div>
} @else {
  <div class="route-item-wrapper">
    @if (featuredItems().length > 0) {
      <div class="route-item-featured">
        @for (item of featuredItems(); track item?.display) {
          <div
            class="route-item route-item--featured"
            [routerLink]="item.url"
            (click)="item?.meta ? onMetaItemClick(item) : onMenuItemClick()"
            [ngClass]="{'route-item--selected': item | isRouteActive: routerUrl()}"
          >
            <mat-icon class="route-item-icon route-item-icon--featured" [svgIcon]="item.icon" />
            <span class="route-item-label route-item-label--featured">{{ item.display }}</span>
          </div>
        }
      </div>
    }
    <div class="route-item-container" [ngClass]="{'route-item-container--single-column': featuredItems().length > 0}">
      @for (item of regularItems(); track item?.display) {
        <div
          class="route-item"
          [routerLink]="item.url"
          (click)="item?.meta ? onMetaItemClick(item) : onMenuItemClick()"
          [ngClass]="{'route-item--selected': item | isRouteActive: routerUrl()}"
        >
          <mat-icon class="route-item-icon" [svgIcon]="item.icon" />
          <span class="route-item-label">{{ item.display }}</span>
        </div>
      }
    </div>
  </div>
}
